import request from '@/utils/request'; // 获取搜索游戏选项

export function searchgame(data) {
  return request({
    url: '/data/search_game',
    method: 'get',
    params: data
  });
} // 数据中心搜索页获取平台列表

export function searchplatform(data) {
  return request({
    url: '/data/search_platform',
    method: 'get',
    params: data
  });
} // 数据中心搜索页获取渠道列表

export function searchchannel(data) {
  return request({
    url: '/data/search_channel',
    method: 'get',
    params: data
  });
} // 数据中心搜索页获取包名列表

export function searchpkg(data) {
  return request({
    url: '/data/search_pkg',
    method: 'get',
    params: data
  });
}
export function searchdataAll(data) {
  return request({
    url: '/data/load_detail_data',
    method: 'get',
    params: data
  });
} // 导出

export function expoatdataAll(data) {
  return request({
    url: '/data/export_load_detail_data',
    method: 'get',
    params: data
  });
} // 获取所有绑定包名

export function getRoleProductPkg(data) {
  return request({
    url: '/data/getRoleProductPkg',
    method: 'get',
    params: data
  });
} // 获取所有绑定广告渠道

export function search_channel_all(data) {
  return request({
    url: '/data/search_channel_all',
    method: 'get',
    params: data
  });
} // 服务器维度数据

export function getServerDataList(data) {
  return request({
    url: '/data/getServerDataList',
    method: 'get',
    params: data
  });
}
export function getServerDataListCurrency(data) {
  return request({
    url: '/data/getServerDataListCurrency',
    method: 'get',
    params: data
  });
} // 获取广告平台

export function searchProductAdvPlatform(data) {
  return request({
    url: '/data/searchProductAdvPlatform',
    method: 'get',
    params: data
  });
} // 充值总额排行榜

export function recharge_total_rank_currency(data) {
  return request({
    url: '/recharge_total_rank_currency',
    method: 'get',
    params: data
  });
} //每日注册列表详情

export function dailyRegisterList(data) {
  return request({
    url: '/data/dailyRegisterList',
    method: 'get',
    params: data
  });
} //玩家每日详情快照

export function hdDailyPlayerDetails(data) {
  return request({
    url: '/data/hdDailyPlayerDetails',
    method: 'post',
    params: data
  });
} //物品留存

export function bagRetainDesc(data) {
  return request({
    url: '/datum/bag_retain_desc',
    method: 'get',
    params: data
  });
} //海盗商业玩法详情

export function businessGameplayDetail(data) {
  return request({
    url: '/data/businessGameplayDetail',
    method: 'get',
    params: data
  });
} //商业玩法映射列表

export function businessGameplayMapList(data) {
  return request({
    url: '/data/businessGameplayMapList',
    method: 'get',
    params: data
  });
} //服务器创角

export function createRoleList(data) {
  return request({
    url: '/data/create-role-list',
    method: 'get',
    params: data
  });
} //商城产销明细

export function marketDetailList(data) {
  return request({
    url: '/data/marketDetailList',
    method: 'get',
    params: data
  });
} //服务器玩家充值排行

export function serverRechargeRankCurrency(data) {
  return request({
    url: '/data/serverRechargeRankCurrency',
    method: 'get',
    params: data
  });
}
export function serverRechargeRank(data) {
  return request({
    url: '/data/serverRechargeRank',
    method: 'get',
    params: data
  });
}
export function dailyTaskRank(data) {
  return request({
    url: '/data/dailyTaskRank',
    method: 'get',
    params: data
  });
}
export function mainLineTaskRank(data) {
  return request({
    url: '/data/mainLineTaskRank',
    method: 'get',
    params: data
  });
}
export function linxutaTaskRank(data) {
  return request({
    url: '/data/linxutaTaskRank',
    method: 'get',
    params: data
  });
}
export function registerUseridByAmountCurrency(data) {
  return request({
    url: '/data/registerUseridByAmountCurrency',
    method: 'get',
    params: data
  });
}
export function registerUseridByAmount(data) {
  return request({
    url: '/data/registerUseridByAmount',
    method: 'get',
    params: data
  });
}
export function serverRoleByAmountCurrency(data) {
  return request({
    url: '/data/serverRoleByAmountCurrency',
    method: 'get',
    params: data
  });
}
export function serverRoleByAmount(data) {
  return request({
    url: '/data/serverRoleByAmount',
    method: 'get',
    params: data
  });
}
export function serverSummaryCurrency(data) {
  return request({
    url: '/data/serverSummaryCurrency',
    method: 'get',
    params: data
  });
}
export function serverSummary(data) {
  return request({
    url: '/data/serverSummary',
    method: 'get',
    params: data
  });
}
export function bagItemList(data) {
  return request({
    url: '/data/bagItemList',
    method: 'get',
    params: data
  });
} // 背包类型列表

export function bagItemTypeList(data) {
  return request({
    url: '/data/bagItemTypeList',
    method: 'get',
    params: data
  });
} //分析数据导出

export function analyzeData(data) {
  return request({
    url: '/data/analyzeData',
    method: 'get',
    params: data
  });
} //玩家上伙伴详情

export function partnerList(data) {
  return request({
    url: '/datum/partnerList',
    method: 'get',
    params: data
  });
} //海盗代金卷消费详情

export function hdVoucherList(data) {
  return request({
    url: '/apply/hd_voucher_list',
    method: 'get',
    params: data
  });
}
export function getSqlRecordList(data) {
  return request({
    url: '/data/getSqlRecordList',
    method: 'get',
    params: data
  });
}
export function eventMap(data) {
  return request({
    url: '/data/eventMap',
    method: 'get',
    params: data
  });
}
export function delEventMap(data) {
  return request({
    url: '/data/delEventMap',
    method: 'post',
    params: data
  });
}
export function addEventMap(data) {
  return request({
    url: '/data/addEventMap',
    method: 'post',
    params: data
  });
}
export function updEventMap(data) {
  return request({
    url: '/data/updEventMap',
    method: 'post',
    params: data
  });
}
export function userBehaviorSequence(data) {
  return request({
    url: '/data/userBehaviorSequence',
    method: 'get',
    params: data
  });
}
export function orderDiffDetail(data) {
  return request({
    url: '/data/orderDiffDetail',
    method: 'get',
    params: data
  });
}
export function orderSummary(data) {
  return request({
    url: '/data/orderSummary',
    method: 'get',
    params: data
  });
}
export function ignorepayservergamelist(data) {
  return request({
    url: '/ignorepayservergamelist',
    method: 'get',
    params: data
  });
}
export function saveIgnorepayserverbygame(data) {
  return request({
    url: '/save-ignorepayserverbygame',
    method: 'post',
    params: data
  });
}
export function deleteIgnorepayserverbygame(data) {
  return request({
    url: '/delete-ignorepayserverbygame',
    method: 'post',
    params: data
  });
}
export function productPurchaseChurnTrend(data) {
  return request({
    url: '/data/productPurchaseChurnTrend',
    method: 'get',
    params: data
  });
}
export function productPurchaseChurnTrendCurrency(data) {
  return request({
    url: '/data/productPurchaseChurnTrendCurrency',
    method: 'get',
    params: data
  });
}
export function multiPeriodCompare(data) {
  return request({
    url: '/data/multiPeriodCompare',
    method: 'get',
    params: data
  });
}